export const BASE_URL =
	"https://api.applaby.com"; /*"http://192.168.39.57:8010";*/
export const API_URL = BASE_URL + "/api/";
export const IFRAME_URL = BASE_URL + "/iframe/";
